import { render, staticRenderFns } from "./EditarDescargaActividadModal.vue?vue&type=template&id=5da49178&"
import script from "./EditarDescargaActividadModal.vue?vue&type=script&lang=ts&"
export * from "./EditarDescargaActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports